import axios from 'axios';
//
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
axios.defaults.headers.common['content-type'] = 'application/json';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

export const setAuthToken = (token: string | null) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export default axios;
